import type { DifficultyLevel } from "./types";

export interface PuzzleDefinition {
  id: string;
  name: string;
  /** Visual seed for procedural art until illustrated images land. */
  seed: number;
  /** Future: `/puzzles/rocket-launch.png` etc. */
  imageUrl?: string;
}

const PUZZLE_POOL: Omit<PuzzleDefinition, "seed">[] = [
  { id: "rocket-launch", name: "Rocket Launch" },
  { id: "moon-landing", name: "Moon Landing" },
  { id: "saturn-rings", name: "Saturn Rings" },
  { id: "nebula-bloom", name: "Nebula Bloom" },
  { id: "space-station", name: "Space Station" },
];

/** Grid size per difficulty — easy 2×2, medium 3×3, hard 4×4. */
export function puzzleGridSize(level: DifficultyLevel): { cols: number; rows: number } {
  switch (level) {
    case "easy":
      return { cols: 2, rows: 2 };
    case "medium":
      return { cols: 3, rows: 3 };
    case "hard":
      return { cols: 4, rows: 4 };
  }
}

export function pickPuzzle(level: DifficultyLevel, challengeKey: number): PuzzleDefinition {
  const poolIndex = (challengeKey + level.length) % PUZZLE_POOL.length;
  const base = PUZZLE_POOL[poolIndex]!;
  return {
    ...base,
    seed: challengeKey * 17 + level.charCodeAt(0) * 31 + poolIndex * 13,
  };
}
